export const getAmountDivider = (amount?: number) => {
  return typeof amount === 'number' ? amount / 100 : 0;
};
